import { observer } from "mobx-react";
import React from "react";
import { Table } from "react-bootstrap";

import { IIvlsDeviceModel } from "@common/models";



interface IIvlsDeviceTableProps {
    ivlsDevices?: IIvlsDeviceModel[];
}

export const IvlsDeviceTable = observer(
    ({ ivlsDevices }: IIvlsDeviceTableProps) => {

        if (_.isEmpty(ivlsDevices))
            return <p>No Ivls Devices were found for this hospital.</p>;

        return (
            <div>
                <Table className="mb-0">
                    <thead>
                        <tr key={"header"} className="">
                            <th>Device Serial Number</th>
                            <th>Display Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {_.orderBy(ivlsDevices, "deviceSerialNumber").map((ivls: IIvlsDeviceModel) => (
                            <tr key={ivls.ivlsDeviceId}>
                                <td className="text-break text-nowrap">{ivls.deviceSerialNumber}</td>
                                <td className="text-break text-nowrap">{ivls.displayName}</td>
                            </tr>
                        ))}

                    </tbody>
                </Table>
            </div>
        );
    }
);
